export var InventoryOmniSearchContainerActionTypes;
(function (InventoryOmniSearchContainerActionTypes) {
    InventoryOmniSearchContainerActionTypes["SET_INVENTORY_OMNI_SEARCH_CONTAINER_STATE"] = "SET_INVENTORY_OMNI_SEARCH_CONTAINER_STATE.inventoryOmniSearchContainer.inventory.state";
    InventoryOmniSearchContainerActionTypes["HANDLE_SEARCH_CHANGE"] = "HANDLE_SEARCH_CHANGE.inventoryOmniSearchContainer.inventory.state";
})(InventoryOmniSearchContainerActionTypes || (InventoryOmniSearchContainerActionTypes = {}));
